import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-4.293 5.953a1 1 0 0 0 -1.414 0l-3 3a1 1 0 0 0 .707 1.707h6c.217 0 .433 -.07 .613 -.21l.094 -.083a1 1 0 0 0 0 -1.414z","key":"svg-0"}]]

const IconCircleCaretUpFilled = createReactComponent('filled', 'circle-caret-up-filled', 'CircleCaretUpFilled', __iconNode);

export default IconCircleCaretUpFilled;